import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function HowToOrder1688() {
  return <ArticleLayout slug="how-to-order-1688" />;
}